/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { List, Input, Modal, Form, InputNumber, Button, message, Card } from "antd";
import { useTranslation } from "react-i18next";
import { apiClient } from "../Api/AllApi";
import "../Styles/Stock.css";
import "../Styles/ListPages.css";

const Stock = () => {
  const [products, setProducts] = useState([]);
  const [dataSource, setDataSource] = useState([]); // Store all products for filtering
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null); // Track the selected product for the modal

  const { i18n, t } = useTranslation();

  useEffect(() => {
    getApiProducts();
  }, []);
  const getApiProducts = async () => {
    try {
      setLoading(true);
      const response = await apiClient.get('/products');

      const productsData = response.data;

      const formattedProducts = productsData.map((item) => {
        const nameObj = JSON.parse(item.name);
        return {
          id: item.id,
          name: nameObj[i18n.language] || nameObj["en"] || "N/A",
          image_url: item.image_url
            ? `${apiClient.defaults.baseURL}/storage/${item.image_url}`
            : null,
          price: item.price,
          sku: item.sku,
          stock: item.stock,
        };
      });

      setDataSource(formattedProducts);
      setProducts(formattedProducts);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [searched, setSearched] = useState(false);

  const onSearch = (value) => {
    if (!value) {
      setProducts([]); // Clear list if search is empty
      setSearched(false); // Hide list when input is empty
    } else {
      const filteredProducts = dataSource.filter((item) =>
        item.sku.toLowerCase().includes(value.toLowerCase())
      );
      setProducts(filteredProducts);
      setSearched(true); // Show list only after search
    }
  };
  // const updateStock = async (id, newStockValue) => {
  //   try {
  //     const updatedValues = { stock: newStockValue };

  //     const response = await apiClient.put(
  //       `/products/${id}`,
  //       updatedValues
  //     );

  //     if (response.status === 200) {
  //       message.success("Stock updated successfully");

  //       // Update the product list without refreshing
  //       setProducts((prevProducts) =>
  //         prevProducts.map((product) =>
  //           product.id === id ? { ...product, stock: newStockValue } : product
  //         )
  //       );

  //       setSelectedProduct(null);
  //     }
  //   } catch (error) {
  //     message.error("Failed to update stock");
  //     console.error("Error updating stock:", error);
  //   }
  // };
  const addStock = async (id, quantity) => {
    try {
      const response = await apiClient.post(
        `/products/${id}/add-stock`,
        { quantity }
      );

      if (response.status === 200) {
        message.success("Stock added successfully");

        // Update the product list without refreshing
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.id === id
              ? { ...product, stock: product.stock + quantity }
              : product
          )
        );

        setSelectedProduct(null);
      }
    } catch (error) {
      message.error("Failed to add stock");
      console.error("Error adding stock:", error);
    }
  };
  const removeStock = async (id, quantity) => {
    try {
      const response = await apiClient.post(
        `/products/${id}/remove-stock`,
        { quantity }
      );

      if (response.status === 200) {
        message.success("Stock removed successfully");

        // Update the product list without refreshing
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.id === id
              ? { ...product, stock: product.stock - quantity }
              : product
          )
        );

        setSelectedProduct(null);
      }
    } catch (error) {
      message.error("Failed to remove stock");
      console.error("Error removing stock:", error);
    }
  };

  const ModalContent = () => {
    const [inputValue, setInputValue] = useState(0);

    if (!selectedProduct) return null;

    const handleIncrement = () => {
      addStock(selectedProduct.id, inputValue);
    };

    const handleDecrement = () => {
      removeStock(selectedProduct.id, inputValue);
    };

    return (
      <Modal
        open={!!selectedProduct}
        onCancel={() => setSelectedProduct(null)}
        footer={null}
        width={400}
      >
        <div style={{ textAlign: "center" }}>
          <h3>{selectedProduct.name}</h3>
          <p>Stock: {selectedProduct.stock}</p>
          <Form>
            <Form.Item>
              <InputNumber
                min={0}
                value={inputValue}
                onChange={(value) => setInputValue(value || 0)}
              />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                onClick={handleIncrement}
                disabled={inputValue <= 0}
              >
                +
              </Button>
              <span style={{ margin: "0 10px" }} />
              <Button
                type="primary"
                onClick={handleDecrement}
                disabled={
                  inputValue <= 0 || selectedProduct.stock - inputValue < 0
                }
              >
                -
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
    );
  };

  return (
    <div className="list-page">
      <Card
        title={
          <span style={{ fontWeight: "600", fontSize: "1.125rem" }}>
            {t("stock")}
          </span>
        }
        bordered={false}
      >
        <Input.Search
          placeholder={t("searchPlaceholder")}
          style={{ marginBottom: 16, maxWidth: 400 }}
          onSearch={onSearch}
          enterButton
          onChange={(e) => {
            if (e.target.value === "") {
              setProducts(dataSource);
            }
          }}
        />

        {searched && (
          <List
          itemLayout="horizontal"
          dataSource={products}
          loading={loading}
          renderItem={(item) => (
            <List.Item
              onClick={() => setSelectedProduct(item)}
              className="list-item"
            >
              <img src={item.image_url} alt="product" height={80} width={80} />
              <div className="product-info">
                <b>{item.name}</b>
                <br />
                {t("sku")}: {item.sku}
                <br />
                {t("stock")}: {item.stock}
              </div>
            </List.Item>
          )}
        />
        )}

        <ModalContent />
      </Card>
    </div>
  );
};

export default Stock;
